export default "__VITE_ASSET__Dj2PCB7M__"